(function($) {

	'use strict';

	function init() {
        initSwiperEvents();
	};

    function initSwiperEvents() {
        let swiper = $('.hpHero__slider')[0].swiper;

        // Changement de l'image de fond du bandeau hero lorsque qu'elle est renseignée dans la slide (paramétrable BO)
        // Event 'slideChange' pour commencer l'animation en même temps que l'animation de changement de slide
        swiper.on('slideChange', function () {
            let active_slide = $(swiper.$el.find('.swiper-slide')).eq(swiper.activeIndex);
            let hero_banner = $('.hpHero__crossfade img');

            // S'il y a une image de bandeau renseignée dans la slide, on l'affiche. Sinon on affiche l'image du bandeau par défaut
            if (active_slide.data('img') != '') {
                hero_banner.attr('src', active_slide.data('img'));
                hero_banner.parent().addClass('active');
            } else {
                hero_banner.parent().removeClass('active');
            }
        });
    }

	$(document).ready(function() {
        if ($('body').hasClass('home')) {
            init();
        }
	});

})(jQuery);
